import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ThemeData } from '../interfaces/theme-data.interface';

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  baseUrl = environment.url;
  themeUrl = 'appraisal/festival/theme/'; // Correct endpoint from learner service
  accessToken = localStorage.getItem('accessToken');

  constructor(private http: HttpClient) { }

  getThemeData(): Observable<ThemeData> {
    const headers = new HttpHeaders().set('Authorization', this.accessToken || '');
    
    console.log('Making API call to:', this.baseUrl + this.themeUrl);
    console.log('With headers:', headers);
    
    return this.http.get<ThemeData>(this.baseUrl + this.themeUrl, { headers })
      .pipe(
        catchError(this.handleError)
      );
  }

  private handleError(error: any) {
    console.error('Theme API Error Details:', {
      status: error.status,
      statusText: error.statusText,
      message: error.message,
      error: error.error,
      url: error.url
    });
    return throwError(() => error);
  }
}